import { externalLinks } from './site'

// SPECIAL (date-specific) EVENTS — the only time-sensitive content on the site.
//
// HOW TO MAINTAIN THIS FILE
// • Add an entry only once BCM leadership confirms it.
// • Leave `visible: false` on anything still being planned; hidden entries are
//   filtered out before rendering, so drafts never reach the page.
// • Omit `time`, `location`, or `date` rather than guessing — the card simply
//   renders fewer lines.
// Recurring weekly activities live in data/recurring.ts, not here.

export type EventStatus = 'Confirmed' | 'Details pending' | 'Draft'

export type BcmEvent = {
  id: string
  category: 'Fall 2026' | 'Weekly' | 'Coming Soon'
  title: string
  /** Human readable date or schedule label. */
  date: string
  /** Leave undefined when a time has not been confirmed. */
  time?: string
  /** Short location line (used in compact cards). */
  location?: string
  /** Fuller location sentence (used on the Events page). */
  locationDetail?: string
  /** Shown in place of a location when details are still pending. */
  locationNote?: string
  description: string
  /** Extra note shown under the details. */
  clarification?: string
  /** Optional verified external call to action (the event's destination). */
  cta?: { label: string; href: string }
  /** Optional verified external reference link. */
  reference?: { label: string; href: string }
  /** Internal maintenance status. Never rendered. */
  status: EventStatus
  /** Gate for public display. */
  visible: boolean
  /** Sortable key. Undated entries sort last. */
  sortKey?: string
}

const specialEvents: BcmEvent[] = [
  {
    id: 'first-worship-night-fall-2026',
    category: 'Fall 2026',
    title: 'First Worship Night',
    date: 'Thursday, August 27, 2026',
    time: '7:30 PM',
    locationNote:
      'Final location and event details will be posted after the leadership retreat.',
    description: 'Join UCF BCM for the first worship night of the fall semester.',
    cta: { label: 'Get Updates', href: externalLinks.getConnectedForm },
    status: 'Details pending',
    visible: true,
    sortKey: '2026-08-27',
  },
  {
    id: 'welcome-week-2026',
    category: 'Coming Soon',
    title: 'Welcome Week Events',
    date: 'Schedule coming soon',
    description: 'Final Welcome Week details will be added after the leadership retreat.',
    status: 'Details pending',
    visible: true,
    sortKey: 'tbd',
  },
]

/** The only events any public component may render. */
export const visibleSpecialEvents: BcmEvent[] = specialEvents.filter((event) => event.visible)

export const announcement = {
  message:
    'First Worship Night: Thursday, August 27 at 7:30 PM • Welcome Week schedule coming soon',
  linkLabel: 'View Events',
  linkTo: '/events',
} as const
